import { network } from 'services/network';

interface IGetMilestonesParams {
    contractId: number;
    filter?: string;
}

export const getMilestones = ({ contractId, filter }: IGetMilestonesParams) => {
    return network
        .post('api/bo/phaseperformance/getMilestones', { contract_id: contractId, filter })
        .then((response) => response.data);
};
